 <template>
  <div class="page-select-template">
    <van-tabs v-model="activeName" color="#3d6eff" @change="getTemplateList" sticky>
      <van-tab title="美发" name="329"></van-tab>
      <van-tab title="美容" name="330"></van-tab>
      <van-tab title="医美" name="331"></van-tab>
      <van-tab title="美甲" name="332"></van-tab>
      <!-- 模板选择 -->
      <div class="context">
        <div class="card contextItem" v-for="item in imageList" :key="item.id">
          <img :src="item.cover" class="image" />
          <div style="padding: 14px;" class="btnTitle">
            <span>{{ item.name }}</span>
            <van-button
              type="info"
              round
              class="button"
              @click="template_id=item.id;storeNameShow=true;msgError=''"
            >立即使用</van-button>
          </div>
        </div>
        <div class="card blank-card" v-if="imageList.length == 0">
          <div class="image-cover-blank">
            <img src="../../assets/images/nocover.png" alt />
            <div class="blank-card-title">创建一套空白模板</div>
            <van-button
              type="info"
              size="small"
              class="default-background"
              shape="circle"
              @click="template_id=-1;storeNameShow=true;msgError=''"
            >立即创建</van-button>
          </div>
        </div>
      </div>
    </van-tabs>
    <van-dialog
      v-model="storeNameShow"
      title="创建店铺名称"
      :show-cancel-button="false"
      :showConfirmButton="false"
    >
      <div style="padding: 30px 20px 6px">
        <van-cell-group>
          <van-field
            v-model="shopName"
            required
            label="店铺名称"
            placeholder="请输入您的店铺名称"
            :error-message="msgError"
            :style="{'margin-bottom': msgError ? '0' : '24px'}"
          />
        </van-cell-group>
      </div>
      <template>
        <div class="dialog-button">
          <van-button type="default" style="flex: 1; border: 0;" @click="storeNameShow=false;">取消</van-button>
          <van-button
            type="default"
            style="flex: 1; border: 0; color: #3d6eff;"
            @click="createStoreName"
          >确认</van-button>
        </div>
      </template>
    </van-dialog>

    <!-- 动画弹框 -->
    <van-dialog
      v-model="animationCreate"
      :show-cancel-button="false"
      :showConfirmButton="false"
      width="300px"
    >
      <div class="loader21 loader">
        <div class="loader-21 loader-box">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <p class="generated-store">正在努力为您生成店铺中...</p>
    </van-dialog>
    <!-- 动画成功 弹框-->
    <van-dialog
      v-model="animationSucceed"
      :show-cancel-button="false"
      :showConfirmButton="false"
      width="300px"
      class="success-dialog"
    >
      <div class="right-into">
        <van-icon name="passed" class="iconfont" />
      </div>
      <p class="generated-store">店铺创建成功，自动进入店铺...</p>
    </van-dialog>
  </div>
</template>
<script>
import {
  getStoreInitialResults,
  getStoreNameIsAvailable,
  getAvailableStoreLinks,
} from '@/api/store'
import { getStore } from '@/api/buy/shop'
import { getTemplateList } from '@/api/api'
import { Dialog, Toast } from 'vant'
import { type } from '@/libs/util'
export default {
  data() {
    return {
      imageList: [], // 图片展示列表
      // 参数模板
      activeName: '329', // 类目模板切换 329美发 330美容 331医美 332美甲
      animationCreate: false, //动画弹框
      animationSucceed: false, //动画弹框成功
      shopName: '', // 店铺名称
      short_url: '', // 店铺短链接
      msgError: '', // 店铺名称错误提示
      storeNameShow: false, // 店铺名称显示隐藏
      template_id: 0, // 当前选中的模板id
      address_value: {}, // 店铺地址
    }
  },
  created() {
    this.address_value = JSON.parse(localStorage.getItem('addressData'))
    // 获取用户选择的模板id
    this.getTemplateList(Number(this.activeName))
  },
  methods: {
    // 切换选择类目
    async changeCategory(name) {
      this.getTemplateList(Number(name))
    },
    getTemplateList(id) {
      // 获取模板列表
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      })
      this.$api
        .getTemplateList({
          category_id: id,
        })
        .then((res) => {
          if (res.code !== 200) {
            return Toast.fail('获取模板列表失败')
          }
          Toast.clear()
          this.imageList = res.response.data
        })
    },
    // 创建店铺名称
    async createStoreName() {
      if (this.shopName.trim() == '')
        return (this.msgError = '店铺名称不能为空')
      // 检测店铺是否存在
      let res = await getStoreNameIsAvailable({
        name: this.shopName,
      })
      if (res.code != 200) return Toast(res.response.msg)
      let res1 = await getAvailableStoreLinks({
        title: this.shopName,
      })
      if (res1.code != 200) return Toast(res1.response.msg)
      if (res1.response.suggest.length >= 6) {
        this.short_url = res1.response.suggest
      } else {
        this.short_url =
          res1.response.suggest + (Date.parse(new Date()) + '').slice(0, 10)
      }
      this.createStore()
    },
    // 创建店铺
    createStore() {
      this.storeNameShow = false
      let params = {
        name: this.shopName,
        short_url: this.short_url,
        store_type: 2, // 0微商城 1零售 2美业 3餐饮
        business_id: this.activeName, // 主营类目 
        business_pattern_id: 1, // 经营模式id
        template_id: this.template_id, // 模板id
        address_value: { ...this.address_value },
      }
      params.address_value.address = `${this.address_value.province_name}${this.address_value.city_name}${this.address_value.area_name}`
      this.animationCreate = true
      this.$api.createStore(params).then((res) => {
        if (res.code == 200 && res.response.success) {
          this.getInitialResults(res.response.id)
        } else {
          Toast(res.msg)
          this.animationCreate = false
        }
      })
    },
    //获取店铺初始化状态
    getInitialResults(storeId) {
      getStoreInitialResults({ store_id: storeId }).then((res) => {
        if (res.code == 200) {
          if (res.response.state) {
            this.animationCreate = false
            this.animationSucceed = true
            setTimeout(this.goPanel(storeId), 5000)
          } else {
            setTimeout(() => {
              this.getInitialResults(storeId)
            }, 5000)
          }
        } else {
          Dialog.confirm({
            title: '提示',
            message: res.msg,
          })
        }
      })
    },
    goPanel(id) {
      let _this = this
      this.$api
        .getShopSign({
          storeid: id,
        })
        .then((res) => {
          if (res.code == '200') {
            _this.$store.commit('changeManageState', id)
            let data = {}
            data.store_id = id
            data.token = res.response
            _this.$store.commit('addShopInfo', data)
            _this.$api.getStoreInfo().then(function (res) {
              if (res.code == '200') {
                let shop = res.response
                shop.token = data.token
                _this.$store.commit('addShopInfo', shop)
                getStore({
                  short_url: shop.shorturl,
                }).then((res1) => {
                  if (res1.code == 200) {
                    _this.$store.commit('setShopIntercept', res1.response.token)
                    _this.$router.push({
                      name: 'success',
                      params: {
                        shop: id,
                      },
                    })
                  } else {
                    Notify({ type: 'danger', message: '获取店铺信息失败' })
                  }
                })
              }
            })
          } else {
            // _this.$ba.trackEvent(
            //   '进入店铺',
            //   'click',
            //   `进入店铺失败：${res.msg}`
            // )
          }
        })
    },
  },
}
</script>

<style lang="css" scoped>
.page-select-template {
  /* height: 100%; */
  background-color: #f8f8f8 !important;
}

img {
  width: 100%;
  height: 244px;
}
.context {
  /* height: 100%; */
  padding: 10px 16px;
}
.image {
  width: 100%;
  vertical-align: middle;
}
.btnTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
}
.contextItem {
  margin-bottom: 22px;
}
.van-dropdown-item {
  margin: 3px 0 !important;
}

/* 动画展示效果 */

.generated-store {
  margin: 0;
  text-align: center;
  color: #999;
  letter-spacing: 1px;
  padding: 10px 0;
}

.right-into {
  text-align: center;
}
.right-into .iconfont {
  font-size: 50px;
  color: #3d6eff;
}

.loader {
  height: 75px;
  justify-content: center;
  display: flex;
  align-items: center;
}
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
.ivu-modal {
  top: 0;
}
@keyframes loader21 {
  0% {
    transform: scale(1, 1);
  }
  100% {
    transform: scale(1, 0.3);
  }
}
.loader-box {
  margin-top: 10px;
}
.loader-box div {
  margin: 0 3px;
}
.loader-21 div {
  width: 5px;
  height: 35px;
  background: #3d6eff;
  border-radius: 2px;
  display: inline-block;
}
.loader-21 div:nth-child(1) {
  animation: loader21 0.5s -0.3s ease-in-out infinite alternate;
}
.loader-21 div:nth-child(2) {
  animation: loader21 0.5s -0.15s ease-in-out infinite alternate;
}
.loader-21 div:nth-child(3) {
  animation: loader21 0.5s 0s ease-in-out infinite alternate;
}
.loader-21 div:nth-child(4) {
  animation: loader21 0.5s -0.15s ease-in-out infinite alternate;
}
.loader-21 div:nth-child(5) {
  animation: loader21 0.5s -0.4s ease-in-out infinite alternate;
}

.image-cover-blank {
  /* display: flex; */
  width: 245px;
  height: 245px;
  text-align: center;
  /* box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08); */
  /* flex-direction: column; */
  /* align-items: center; */
  margin: 0;
}
.image-cover-blank > img {
  display: block;
  width: 100%;
}
.blank-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 50px;
  padding-top: 20px;
  margin-bottom: 10px;
}
.blank-card-title {
  margin: 10px 0;
  font-size: 16px;
}
.btnTitle > .van-button {
  /* margin-bottom: 10px !important; */
  height: 28.5px;
  /* width: 87px; */
  font-size: 14px;
  line-height: 28.5px;
}
.card {
  width: 100%;
  height: 304px;
  background-color: #ffffff;
  box-shadow: 0px 4px 6px 2px rgba(96, 105, 114, 0.08);
  border-radius: 6px;
  overflow: hidden;
}
/* 颜色处理 */
.color-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.color-list-item {
  height: 20px;
  width: 40px;
  border-radius: 10px;
  overflow: hidden;
  margin: 10px 18px;
  height: 16px;
}
.color-item {
  height: 16px;
  width: 40px;
  overflow: hidden;
  border-radius: 10px;
}
.colorBox {
  width: 20px;
  height: 16px;
  float: left;
}
.success-dialog {
  padding: 20px 10px;
}
.van-button--info {
  color: #fff;
  background-color: #3d6eff;
  border: 0.02667rem solid #3d6eff;
}
.no-impos {
  width: 40px;
  height: 16px;
  line-height: 16px;
  /* border-radius: 5px; */
  /* overflow: hidden; */
  font-size: 14px;
  text-align: center;
}
.current {
  border: 2px solid #3d6eff;
  border-radius: 12px;
  /* box-sizing: border-box; */
  padding: 2px;
  margin: 6px 14px;
  color: #3d6eff;
}
.dialog-button {
  display: flex;
  width: 100%;
}
</style>
